import { Component, OnInit } from '@angular/core';
import { UtilHelper } from '../shared/helpers/util-helper';

@Component({
  selector: 'sarf-pagina-inicial',
  templateUrl: './pagina-inicial.component.html',
  styleUrls: ['./pagina-inicial.component.scss']
})
export class PaginaInicialComponent implements OnInit {

  constructor() {
    UtilHelper.RemoverManterConsulta();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pagina-inicial/pagina-inicial.component.ts